import type { CalendarEvent } from 'owa-calendar-types';
import canModify from './canModify';
import { isCalendarEventLocalLie } from 'owa-calendar-event-local-lie';

/**
 * Determines if the categories menu is to be shown
 * @param item Calendar event object
 */
export default (item: CalendarEvent): boolean => {
    return isCalendarEventLocalLie(item) || canModify(item);
};
